import React, { useState, useEffect, useContext } from "react";
import Swal from "sweetalert2";

const AppContext = React.createContext()

const AppProvider = ({ children }) => {
    const getData = () => {
        const data = JSON.parse(localStorage.getItem("cart"))
        if(data){
            return data
        }else{
            return []
        }
    }
    //STATES-----------------
    const [cart, setCart] = useState(getData())
    const [showdetail, setShowdetail] = useState(false)
    const [product, setProduct] = useState({})
    const [size , setSize] = useState("")
    const [qtyInStore , setQtyInStore] = useState("")
    const [route , setRoute] = useState("")
    const [totalFilter, setTotalFilter] = useState({search : "", min : 1 , max : 10000000 , cat : "" , color : ""})
    const [savedAddress, setSavedAddress] = useState([])
    //----------------------
    //FUNCTIONS------------------
    const handleErr = (type, text) => {
        Swal.fire({
            title: type == "error" ? "خطا" : "موفق",
            text: text,
            icon: type,
            confirmButtonText: 'باشه'
        })
    }
    const handleShowDetail = (item) => {
        let product = {
            name: item.title,
            img : item.img,
            code: item.productCode,
            price: item.price,
            size: item.sizes,
            qty: 1,
            store : item.instock
        }   
        setProduct(product)
    }
    const handleQuentity = (type) => {
        if (type == "I") {
            if (product.qty >= qtyInStore) {
                return handleErr("error", `تنها ${qtyInStore} عدد از این محصول با سایز (${size}) موجود است.`)
            }
            setProduct(
                { ...product, qty: product.qty >= qtyInStore ? qtyInStore : product.qty + 1 }
            )
        } else {
            setProduct(
                { ...product, qty: product.qty <= 1 ? 1 : product.qty - 1 }
            )
        }
    }
    const handleAddProductToCart = () => {
        let pro = {
            name: product.name,
            img: product.img,
            code: product.code,
            price: product.price,
            size: size ? size : "",
            qty: product.qty,
            store : qtyInStore
        }
        if (pro.size == "") {
            return handleErr("error", "سایز مورد نظر را انتخاب کنید.")
        } else {
            const duplicatedPro = cart.find(item => item.code == pro.code && item.size == pro.size)
            if(duplicatedPro){
                return handleErr("error", "این محصول قبلا به سبد خرید اضافه شده است.")
            }
            setCart([...cart , pro])
            setSize("")
            setQtyInStore("")
            setProduct({...product , qty : 1})
            return handleErr("success", "باموفقیت به سبد خرید اضافه شد.")
        }
    }
    localStorage.setItem("cart" , JSON.stringify(cart))

    const removeFromCart = (code , size) => {
        const filter = cart.filter(item => item.code !== code || item.size !== size)
        setCart(filter)
    }
    const changeQuentityInCart = (code , size , type , qtyInStore) => {
        if(type == "I"){
            setCart(
                cart.map(item => item.code == code && item.size == size ? {...item , qty : item.qty >= qtyInStore ? qtyInStore : item.qty + 1} : item)
            )
        }else{
            setCart(
                cart.map(item => item.code == code && item.size == size ? {...item , qty : item.qty <= 1 ? 1 : item.qty - 1} : item)
            )
        }
    }
    const handleDeleteFilter = () => {
        setTotalFilter({search : "" ,min : 1 , max : 10000000 , color : "" , cat : ""})
    }
    //---------------------------

    return <AppContext.Provider value={{
        //FUNCTIONS----
        handleShowDetail,
        handleQuentity,
        handleAddProductToCart,
        removeFromCart,
        changeQuentityInCart,
        handleErr,
        handleDeleteFilter,
        //--------------
        //STATES------- 
        cart,
        setCart,
        product,
        setProduct,
        size,
        setSize,
        qtyInStore,
        setQtyInStore,
        showdetail,
        setShowdetail,
        totalFilter,
        setTotalFilter,
        route,
        setRoute,
        savedAddress,
        setSavedAddress,
        //-------------
    }}>{children}</AppContext.Provider>

}

const useGlobalContext = () => {
    return useContext(AppContext)
}

export { AppProvider, AppContext, useGlobalContext }